module.exports = __webpack_public_path__ + "static/media/familyCooking1440.de093685.jpeg";